import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { EllipsisTooltipDirective } from '../../../common/ellipsis-tooltip/ellipsis-tooltip.directive';
import { CardContentSharryFragment } from '../../../common/fragments/card-content.fragment.generated';
import { VariantDatePipe } from '../../../common/variant/variant-date/variant-date.pipe';
import { GtagService } from '../../../common/gtag/gtag.service';
import { SlugPipe } from '../../pipes/slug.pipe';

@Component({
  selector: 'sharry-big-card',
  standalone: true,
  templateUrl: './big-card.component.html',
  styleUrls: ['./big-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    I18NextModule,
    EllipsisTooltipDirective,
    SlugPipe,
    RouterLink,
    VariantDatePipe,
  ],
})
export class BigCardComponent {
  @Input() content: CardContentSharryFragment;

  constructor(private gtagService: GtagService) {}

  triggerViewItem(card: any) {
    this.gtagService.pushEvent(
      {
        event: 'select_item',
        ecommerce: {
          items: [
            {
              item_name: card?.title,
              item_id: card?.id,
              ...(card?.contentType === 'sharry' && { price: card?.nextUpcomingVariant?.discountedPrice }),
              item_brand: card?.owner?.businessName,
              item_category: card?.sharryKind?.name,
              item_variant: card?.sharrySelection,
            },
          ],
        },
      },
      true,
    );
  }
}
